import React, { useState } from 'react';
import { headerEndpoints, sceneLineLabel } from '../../utils/plottrackGrid';
import {
  ACT_RUNS_FROM,
  CANCEL_HEADER_SPAN,
  CHAPTER_RUNS_FROM,
  ENDS_AT_SCENE,
  HEADER_RUNS_TO,
  SAVE_HEADER_SPAN,
  SEQUENCE_RUNS_FROM,
  STARTS_AT_SCENE,
} from '../../utils/writerCopy';

function spanKindCopy(kind) {
  if (kind === 'act') return { runsFrom: ACT_RUNS_FROM, fallback: 'Act' };
  if (kind === 'chapter') return { runsFrom: CHAPTER_RUNS_FROM, fallback: 'Chapter' };
  return { runsFrom: SEQUENCE_RUNS_FROM, fallback: 'Sequence' };
}

function spanErrorCopy(err) {
  const raw = String(err?.message || '').trim();
  const stripped = raw.replace(/^VALIDATION:\s*[^-]+-\s*/, '').trim();
  return stripped || 'Could not save where this runs.';
}

export default function PlotTrackHeaderSpan({
  kind,
  header,
  columns,
  onSave,
  onCancel,
}) {
  const ends = headerEndpoints(header, columns);
  const [startSceneId, setStartSceneId] = useState(String(ends.startSceneId || ''));
  const [endSceneId, setEndSceneId] = useState(String(ends.endSceneId || ''));
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);
  const { runsFrom, fallback } = spanKindCopy(kind);
  const title = header?.display_name || fallback;

  const save = async (event) => {
    event.preventDefault();
    if (!startSceneId || !endSceneId) return;
    setSaving(true);
    setError(null);
    try {
      await onSave({
        headerId: header.id,
        startSceneId,
        endSceneId,
      });
    } catch (err) {
      setError(spanErrorCopy(err));
      setSaving(false);
    }
  };

  return (
    <form className="pt-grid__span-form" onSubmit={save} aria-label={`${title}: ${runsFrom}`}>
      <p className="pt-grid__span-copy">{runsFrom}</p>
      <label className="pt-grid__span-field">
        <span>{STARTS_AT_SCENE}</span>
        <select
          value={startSceneId}
          aria-label={STARTS_AT_SCENE}
          onChange={(event) => setStartSceneId(event.target.value)}
        >
          {(columns || []).map((column, index) => (
            <option key={column.scene_id} value={column.scene_id}>
              {sceneLineLabel(column, index)}
            </option>
          ))}
        </select>
      </label>
      <p className="pt-grid__span-copy">{HEADER_RUNS_TO}</p>
      <label className="pt-grid__span-field">
        <span>{ENDS_AT_SCENE}</span>
        <select
          value={endSceneId}
          aria-label={ENDS_AT_SCENE}
          onChange={(event) => setEndSceneId(event.target.value)}
        >
          {(columns || []).map((column, index) => (
            <option key={column.scene_id} value={column.scene_id}>
              {sceneLineLabel(column, index)}
            </option>
          ))}
        </select>
      </label>
      {error && <p className="pt-grid__span-error">{error}</p>}
      <span className="pt-grid__span-actions">
        <button type="submit" disabled={saving || !startSceneId || !endSceneId}>
          {SAVE_HEADER_SPAN}
        </button>
        <button type="button" onClick={onCancel} disabled={saving}>
          {CANCEL_HEADER_SPAN}
        </button>
      </span>
    </form>
  );
}
